import type { ReactNode } from "react";
import className from "~/kernel/styling/className";

type TextProps = {
  variant?: TextVariant;
  as?: "p" | "span";
  children: ReactNode;
  color?: TextColor;
  overflow?: "visible" | "ellipsis";
  whitespace?: "initial" | "nowrap";
  weight?: "regular" | "bold";
  leading?: "normal" | "relaxed";
};

const TEXT_COLORS = {
  body: "text-slate-600",
  muted: "text-slate-500",
  blue: "text-secondary",
  error: "text-error",
  warning: "text-warning",
};

type TextColor = keyof typeof TEXT_COLORS;

const VARIANTS = {
  bodyMedium: "",
  bodyXs: "text-xs",
};

type TextVariant = keyof typeof VARIANTS;

export default function Text({
  children,
  variant = "bodyMedium",
  as = inferAs(variant),
  color = "body",
  overflow = "visible",
  whitespace = "initial",
  weight = "regular",
  leading = "normal",
}: TextProps) {
  const Component = as;
  return (
    <Component
      className={className(VARIANTS[variant], TEXT_COLORS[color], {
        "font-bold": weight === "bold",
        "whitespace-nowrap": whitespace === "nowrap",
        "text-ellipsis overflow-hidden": overflow === "ellipsis",
        "leading-relaxed": leading === "relaxed",
        "leading-normal": leading === "normal",
      })}
    >
      {children}
    </Component>
  );
}

function inferAs(variant: TextVariant) {
  switch (variant) {
    case "bodyMedium":
      return "p";
    default:
      return "span";
  }
}
